export function getAttr(el, attr) {
  return el.getAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/getAttr.js
// module id = 85
// module chunks = 0